<div id="dark" [style]="(isMarket)?'margin-top:75px':'margin-top:110px'">
  <!-- <div style="background-color: #1c1c1c; font-size: small;" class="card" *ngIf="company.ENG_NAME != null">
        <div class="p-1">
          <div class="d-flex justify-content-between" style="cursor: default;">
            <div class="p-1 font-weight-bold" style="text-overflow:ellipsis !important;color:rgb(190, 190, 190);font-size: 14px;white-space: nowrap;overflow: hidden;">
              {{company.Reuters}}
            </div>
            <div style="font-size: 15px;" class="p-1" [ngClass]="company.LAST_CHANGE_PRC>0? 'green' : 'red'">
              {{company.LAST_CHANGE_PRC | number : '1.2-2'}}%
              <i class="ion-md-trending-up" *ngIf="company.LAST_CHANGE_PRC>0"></i>
              <i class="ion-md-trending-down" *ngIf="company.LAST_CHANGE_PRC<0"></i>
            </div>
          </div>
          <div class="d-flex justify-content-between" style="max-width: 100%;">
            <div class="p-1" style="text-overflow:ellipsis !important;font-size:13px;color:rgb(238, 238, 238); white-space: nowrap;overflow: hidden;">
              {{(translate.currentLang=='en')?company.ENG_NAME:company.ARB_NAME}}
            </div>
            <div class="p-1" style="color:rgb(238, 238, 238); font-size: 15px;">
              {{company.LAST_TRADE_PRICE | currency:"EGP":"symbol"}}
            </div>
          </div>
        </div>
      </div> -->

  <!-- <div *ngIf="companies?.length>0">
    <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
      <div *ngFor="let company of companies" ngxSlickItem>
        <div style="background-color: #1c1c1c; font-size: small;" class="card">
          <div class="p-1">
            <div class="d-flex justify-content-between" style="cursor: default;">
              <div class="p-1 font-weight-bold" style="text-overflow:ellipsis !important;color:rgb(190, 190, 190);font-size: 14px;white-space: nowrap;overflow: hidden;">
                {{company.Reuters}}
              </div>
              <div style="font-size: 15px;" class="p-1" [ngClass]="company.LAST_CHANGE_PRC>0? 'green' : 'red'">
                {{company.LAST_CHANGE | number : '1.2-2'}} ({{company.LAST_CHANGE_PRC | number : '1.2-2'}}%)

                <i class="ion-md-trending-up" *ngIf="company.LAST_CHANGE_PRC>0"></i>
                <i class="ion-md-trending-down" *ngIf="company.LAST_CHANGE_PRC<0"></i>
              </div>
            </div>
            <div class="d-flex justify-content-between" style="max-width: 100%;">
              <div class="p-1" style="text-overflow:ellipsis !important;color:rgb(238, 238, 238);max-width: 70%; font-size: 12px; white-space: nowrap;overflow: hidden;">
                {{(translate.currentLang=='en')?company.ENG_NAME:company.ARB_NAME}}
              </div>
              <div class="p-1" [ngStyle]="(translate.currentLang == 'en')?'':{'unicode-bidi': 'plaintext'}" style="color:rgb(238, 238, 238); font-size: 15px">
                {{company.LAST_TRADE_PRICE | number : '1.2-2'}}
                <span *ngIf="company.CURRENCY == 1" class="text-muted" style="font-size: 11px;">
                  EGP
                </span>
                <span *ngIf="company.CURRENCY == 2" class="text-muted" style="font-size: 11px;">
                  $
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ngx-slick-carousel>
  </div> -->

  <div class="fab-custom">
    <button mat-mini-fab class="action-button" [popoverClass]="'content'" [ngbPopover]="popContent" placement="right"><mat-icon>dashboard</mat-icon></button>
    <ng-template #popContent>

      <button class="btn btn-sm btn-primary shadow-none dashboard-item" *ngFor="let item of dashboardList;let i = index" (click)="switchDashboard(i)" [ngClass]="(i==dashboardIndex)?'selected':''">
        {{'Layout ' + (i+1)}}
        <mat-icon *ngIf="this.dashboardList.length>1" class="remove" (click)="removeDashboard(i)">close</mat-icon>
      </button>
      <button mat-mini-fab color="secondary" class="mx-2" (click)="addNewDashboard()">
        <mat-icon>plus_one</mat-icon>
      </button>

    </ng-template>
  </div>

  <div *ngIf="companies?.length>0 && this.accService.Ticker">
    <ngx-marquee style="direction: ltr;" pauseOnHover="true" [duration]="(companies.length*2)+'s'">
      <div *ngFor="let company of companies" style="display: inline-block; cursor: pointer;" (click)="navigateProfile(company)">
        <div style="font-size: small; " class="card demo-wrap-card-bg text-color-theme">
          <div class="p-1" [ngStyle]="(translate.currentLang == 'ar')?{direction: 'rtl'}:''">
            <div class="d-flex justify-content-between">
              <div class="p-1 font-weight-bold demo-wrap-card-header-text" style="text-overflow:ellipsis !important;font-size: 14px;white-space: nowrap;overflow: hidden;">
                {{company.Reuters}}
              </div>
              <div style="font-size: 15px;" class="p-1" [ngClass]="company.LAST_CHANGE_PRC>0? 'green' : 'red'">
                {{company.LAST_CHANGE | number : '1.2-2'}} ({{company.LAST_CHANGE_PRC | number : '1.2-2'}}%)

                <i class="ion-md-trending-up" *ngIf="company.LAST_CHANGE_PRC>0"></i>
                <i class="ion-md-trending-down" *ngIf="company.LAST_CHANGE_PRC<0"></i>
              </div>
            </div>
            <div class="d-flex justify-content-between" style="max-width: 100%;">
              <div class="p-1 demo-wrap-card-text" style="text-overflow:ellipsis !important;font-size:14px;white-space: nowrap;overflow: hidden;">
                {{(translate.currentLang=='en')?company.ENG_NAME:company.ARB_NAME}}
              </div>
              <div class="p-1 demo-wrap-card-text" style="font-size: 15px;">
                {{company.LAST_TRADE_PRICE | currency:"EGP":"symbol"}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </ngx-marquee>
  </div>
  <!-- style="overflow: visible !important; z-index: 0 !important;" -->
  <gridster [options]="options">
    <gridster-item [item]="item" *ngFor="let item of dashboard; let i = index" [ngClass]="{'market-grid': item.name === 'market-watch'}">
      <div class="d-flex" class="item-buttons close-widget">
        <button *ngIf="item.dragEnabled" mat-icon-button class="drag-handler" style="cursor: grab;">
          <mat-icon style="font-size: 18px;">open_with</mat-icon>
        </button>
        <button mat-icon-button (click)="removeItem($event,item)">
          <mat-icon style="font-size: 18px;">close</mat-icon>
        </button>
      </div>
      <div class="trades-news gridster-item-content">
        <ndc-dynamic #MWT [ndcDynamicComponent]="get(item.name)" [ndcDynamicInputs]="{symbolCode:(item.symbolCode == null)?
          selectedCompanySymbol:item.symbolCode, reuters:(item.reuters == null)?
          selectedCompanyReuters:item.reuters,isLinked:item.isLinked, companyName:(item.companyName == null)?
          selectedCompanyName:item.companyName, state:(item.state==null)?'':item.state, id:i}">
        </ndc-dynamic>
      </div>
    </gridster-item>
  </gridster>

</div>
